export default "__VITE_ASSET__CY7wMcRO__"